// Shared avatar helpers for the meeting UI.
// Colors are pulled from CSS custom properties defined in MeetingPage.scss
// (--mursal-avatar-1..5), which are themselves derived from a curated
// identity palette ($primary, $avatar-teal, $avatar-violet,
// $avatar-terracotta, $avatar-slate). This keeps a single source of
// truth for "identity" colors across SCSS and JS, and keeps them
// separate from the semantic status colors (green/amber/red) used
// elsewhere in the UI.

const AVATAR_VARS = [
  "var(--mursal-avatar-1)",
  "var(--mursal-avatar-2)",
  "var(--mursal-avatar-3)",
  "var(--mursal-avatar-4)",
  "var(--mursal-avatar-5)",
];

export const getInitials = (name = "") => {
  const clean = String(name).trim();
  if (!clean) return "?";

  const parts = clean.split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();

  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const getAvatarColor = (seed = "") => {
  const str = String(seed);
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) % AVATAR_VARS.length;
  }

  return AVATAR_VARS[Math.abs(hash) % AVATAR_VARS.length];
};
